export default __webpack_public_path__ + "static/media/SRH BERLIN DRESDEN.d78acb1b.png";